module.exports = __webpack_public_path__ + "img/page_bg.fd4ac65f.png";